import { theme } from '@atlas/shared/client/ui/core/theming';
import { unsafeCSS, css } from 'lit';
import { focusBorderMixin } from '../mixins/focusBorder';

export const superElementStyle = css`
    :host {
        /* PRIMARY COLORS */
        --lr-background-primary: ${unsafeCSS(theme.colors.semantic.action.background.primary.default)};
        --lr-background-primary-hover: ${unsafeCSS(theme.colors.semantic.action.background.primary.hover)};
        --lr-background-primary-active: ${unsafeCSS(theme.colors.semantic.action.background.primary.active)};
        --lr-background-primary-disabled: ${unsafeCSS(theme.colors.semantic.action.background.primary.disabled)};
        --lr-background-primary-reversed: ${unsafeCSS(
            theme.colors.semantic.action.background.primary.reversed.default
        )};
        --lr-background-primary-reversed-hover: ${unsafeCSS(
            theme.colors.semantic.action.background.primary.reversed.hover
        )};
        --lr-background-primary-reversed-active: ${unsafeCSS(
            theme.colors.semantic.action.background.primary.reversed.active
        )};
        --lr-background-primary-reversed-disabled: ${unsafeCSS(
            theme.colors.semantic.action.background.primary.reversed.disabled
        )};
        --lr-color-primary: ${unsafeCSS(theme.colors.semantic.action.content.primary.default)};
        --lr-color-primary-hover: ${unsafeCSS(theme.colors.semantic.action.content.primary.hover)};
        --lr-color-primary-active: ${unsafeCSS(theme.colors.semantic.action.content.primary.active)};
        --lr-color-primary-disabled: ${unsafeCSS(theme.colors.semantic.action.content.primary.disabled)};
        --lr-color-primary-reversed: ${unsafeCSS(theme.colors.semantic.action.content.primary.reversed.default)};
        --lr-color-primary-reversed-hover: ${unsafeCSS(theme.colors.semantic.action.content.primary.reversed.hover)};
        --lr-color-primary-reversed-active: ${unsafeCSS(theme.colors.semantic.action.content.primary.reversed.active)};
        --lr-color-primary-reversed-disabled: ${unsafeCSS(
            theme.colors.semantic.action.content.primary.reversed.disabled
        )};
        /* SECONDARY COLORS */
        --lr-background-secondary: ${unsafeCSS(theme.colors.semantic.action.background.secondary.default)};
        --lr-background-secondary-hover: ${unsafeCSS(theme.colors.semantic.action.background.secondary.hover)};
        --lr-background-secondary-active: ${unsafeCSS(theme.colors.semantic.action.background.secondary.active)};
        --lr-background-secondary-disabled: ${unsafeCSS(theme.colors.semantic.action.background.secondary.disabled)};
        --lr-background-secondary-reversed: ${unsafeCSS(
            theme.colors.semantic.action.background.secondary.reversed.default
        )};
        --lr-background-secondary-reversed-hover: ${unsafeCSS(
            theme.colors.semantic.action.background.secondary.reversed.hover
        )};
        --lr-background-secondary-reversed-active: ${unsafeCSS(
            theme.colors.semantic.action.background.secondary.reversed.active
        )};
        --lr-background-secondary-reversed-disabled: ${unsafeCSS(
            theme.colors.semantic.action.background.secondary.reversed.disabled
        )};
        --lr-color-secondary: ${unsafeCSS(theme.colors.semantic.action.content.secondary.default)};
        --lr-color-secondary-hover: ${unsafeCSS(theme.colors.semantic.action.content.secondary.hover)};
        --lr-color-secondary-active: ${unsafeCSS(theme.colors.semantic.action.content.secondary.active)};
        --lr-color-secondary-disabled: ${unsafeCSS(theme.colors.semantic.action.content.secondary.disabled)};
        --lr-color-secondary-reversed: ${unsafeCSS(theme.colors.semantic.action.content.secondary.reversed.default)};
        --lr-color-secondary-reversed-hover: ${unsafeCSS(
            theme.colors.semantic.action.content.secondary.reversed.hover
        )};
        --lr-color-secondary-reversed-active: ${unsafeCSS(
            theme.colors.semantic.action.content.secondary.reversed.active
        )};
        --lr-color-secondary-reversed-disabled: ${unsafeCSS(
            theme.colors.semantic.action.content.secondary.reversed.disabled
        )};
        /* TERTIARY COLORS */
        --lr-background-tertiary: ${unsafeCSS(theme.colors.semantic.action.background.tertiary.default)};
        --lr-background-tertiary-hover: ${unsafeCSS(theme.colors.semantic.action.background.tertiary.hover)};
        --lr-background-tertiary-active: ${unsafeCSS(theme.colors.semantic.action.background.tertiary.active)};
        --lr-background-tertiary-disabled: ${unsafeCSS(theme.colors.semantic.action.background.tertiary.disabled)};
        --lr-background-tertiary-reversed: ${unsafeCSS(
            theme.colors.semantic.action.background.tertiary.reversed.default
        )};
        --lr-background-tertiary-reversed-hover: ${unsafeCSS(
            theme.colors.semantic.action.background.tertiary.reversed.hover
        )};
        --lr-background-tertiary-reversed-active: ${unsafeCSS(
            theme.colors.semantic.action.background.tertiary.reversed.active
        )};
        --lr-background-tertiary-reversed-disabled: ${unsafeCSS(
            theme.colors.semantic.action.background.tertiary.reversed.disabled
        )};
        --lr-color-tertiary: ${unsafeCSS(theme.colors.semantic.action.content.tertiary.default)};
        --lr-color-tertiary-hover: ${unsafeCSS(theme.colors.semantic.action.content.tertiary.hover)};
        --lr-color-tertiary-active: ${unsafeCSS(theme.colors.semantic.action.content.tertiary.active)};
        --lr-color-tertiary-disabled: ${unsafeCSS(theme.colors.semantic.action.content.tertiary.disabled)};
        --lr-color-tertiary-reversed: ${unsafeCSS(theme.colors.semantic.action.content.tertiary.reversed.default)};
        --lr-color-tertiary-reversed-hover: ${unsafeCSS(theme.colors.semantic.action.content.tertiary.reversed.hover)};
        --lr-color-tertiary-reversed-active: ${unsafeCSS(
            theme.colors.semantic.action.content.tertiary.reversed.active
        )};
        --lr-color-tertiary-reversed-disabled: ${unsafeCSS(
            theme.colors.semantic.action.content.tertiary.reversed.disabled
        )};
        /* LINK COLOR */
        --lr-color-link: ${unsafeCSS(theme.colors.semantic.action.content.link.default)};
        --lr-color-link-hover: ${unsafeCSS(theme.colors.semantic.action.content.link.hover)};
        --lr-color-link-active: ${unsafeCSS(theme.colors.semantic.action.content.link.active)};
        --lr-color-link-disabled: ${unsafeCSS(theme.colors.semantic.action.content.link.disabled)};
        --lr-color-link-reversed: ${unsafeCSS(theme.colors.semantic.action.content.link.reversed.default)};
        --lr-color-link-reversed-hover: ${unsafeCSS(theme.colors.semantic.action.content.link.reversed.hover)};
        --lr-color-link-reversed-active: ${unsafeCSS(theme.colors.semantic.action.content.link.reversed.active)};
        --lr-color-link-reversed-disabled: ${unsafeCSS(theme.colors.semantic.action.content.link.reversed.disabled)};
        /* SECONDARY BORDER */
        --lr-border-secondary-color: ${unsafeCSS(theme.colors.semantic.action.border.secondary.default)};
        --lr-border-secondary-color-hover: ${unsafeCSS(theme.colors.semantic.action.border.secondary.hover)};
        --lr-border-secondary-color-active: ${unsafeCSS(theme.colors.semantic.action.border.secondary.active)};
        --lr-border-secondary-color-disabled: ${unsafeCSS(theme.colors.semantic.action.border.secondary.disabled)};
        --lr-border-secondary-color-reversed: ${unsafeCSS(
            theme.colors.semantic.action.border.secondary.reversed.default
        )};
        --lr-border-secondary-color-reversed-hover: ${unsafeCSS(
            theme.colors.semantic.action.border.secondary.reversed.hover
        )};
        --lr-border-secondary-color-reversed-active: ${unsafeCSS(
            theme.colors.semantic.action.border.secondary.reversed.active
        )};
        --lr-border-secondary-color-reversed-disabled: ${unsafeCSS(
            theme.colors.semantic.action.border.secondary.reversed.disabled
        )};
        /* INFORMATIONS COLORS */
        --lr-info-100: ${unsafeCSS(theme.colors.base.information.tone100)};
        --lr-info-200: ${unsafeCSS(theme.colors.base.information.tone200)};
        --lr-info-300: ${unsafeCSS(theme.colors.base.information.tone300)};
        --lr-info-400: ${unsafeCSS(theme.colors.base.information.tone400)};
        --lr-info-500: ${unsafeCSS(theme.colors.base.information.tone500)};
        --lr-info-600: ${unsafeCSS(theme.colors.base.information.tone600)};
        --lr-info-700: ${unsafeCSS(theme.colors.base.information.tone700)};
        --lr-info-800: ${unsafeCSS(theme.colors.base.information.tone800)};
        --lr-info-900: ${unsafeCSS(theme.colors.base.information.tone900)};
        /* GREYS COLORS */
        --lr-greys-000: ${unsafeCSS(theme.colors.base.greys.tone000)};
        --lr-greys-100: ${unsafeCSS(theme.colors.base.greys.tone100)};
        --lr-greys-200: ${unsafeCSS(theme.colors.base.greys.tone200)};
        --lr-greys-300: ${unsafeCSS(theme.colors.base.greys.tone300)};
        --lr-greys-400: ${unsafeCSS(theme.colors.base.greys.tone400)};
        --lr-greys-500: ${unsafeCSS(theme.colors.base.greys.tone500)};
        --lr-greys-600: ${unsafeCSS(theme.colors.base.greys.tone600)};
        --lr-greys-700: ${unsafeCSS(theme.colors.base.greys.tone700)};
        --lr-greys-800: ${unsafeCSS(theme.colors.base.greys.tone800)};
        --lr-greys-900: ${unsafeCSS(theme.colors.base.greys.tone900)};
        /* PADDINGS SIZES VERTICAL */
        --lr-px-4: ${unsafeCSS(theme.spacing(0.75))}; /* 0.25rem 4px */
        --lr-px-8: ${unsafeCSS(theme.spacing(1))}; /* 0.5rem 8px */
        --lr-px-10: ${unsafeCSS(theme.spacing(1.25))}; /* 0.625rem 10px */
        --lr-px-12: ${unsafeCSS(theme.spacing(1.5))}; /* 0.75rem 12px */
        --lr-px-14: ${unsafeCSS(theme.spacing(1.75))}; /* 0.875rem 14px */
        --lr-px-16: ${unsafeCSS(theme.spacing(2))}; /* 1rem 16px */
        --lr-px-18: ${unsafeCSS(theme.spacing(2.25))}; /* 1.125rem 18px */
        --lr-px-20: ${unsafeCSS(theme.spacing(2.5))}; /* 1.25rem 20px */
        --lr-px-26: ${unsafeCSS(theme.spacing(3.25))}; /* 1.625rem 26px */
        --lr-px-32: ${unsafeCSS(theme.spacing(4))}; /* 2rem 32px */
        --lr-px-36: ${unsafeCSS(theme.spacing(4.5))}; /* 2.25rem 36px */
        --lr-px-40: ${unsafeCSS(theme.spacing(5))}; /* 2.5rem 40px */
        --lr-px-44: ${unsafeCSS(theme.spacing(5.5))}; /* 2.75rem 44px */
        /* PADDINGS SIZES HORIZONTAL */
        --lr-py-2: ${unsafeCSS(theme.spacing(0.25))}; /* 0.125rem 2px */
        --lr-py-4: ${unsafeCSS(theme.spacing(0.75))}; /* 0.25rem 4px */
        --lr-py-8: ${unsafeCSS(theme.spacing(1))}; /* 0.5rem 8px */
        --lr-py-10: ${unsafeCSS(theme.spacing(1.25))}; /* 0.625rem 10px */
        --lr-py-12: ${unsafeCSS(theme.spacing(1.5))}; /* 0.75rem 12px */
        --lr-py-14: ${unsafeCSS(theme.spacing(1.75))}; /* 0.875rem 14px */
        --lr-py-16: ${unsafeCSS(theme.spacing(2))}; /* 1rem 16px */
        --lr-py-18: ${unsafeCSS(theme.spacing(2.25))}; /* 1.125rem 18px */
        --lr-py-20: ${unsafeCSS(theme.spacing(2.5))}; /* 1.25rem 20px */
        --lr-padding-small: var(--lr-py-12) var(--lr-px-20);
        --lr-padding-medium: var(--lr-py-14) var(--lr-px-26);
        --lr-padding-big: var(--lr-py-14) var(--lr-px-32);
        /* MARGINS SIZES VERTICAL */
        --lr-mx-12: ${unsafeCSS(theme.spacing(1.5))}; /* 0.75rem 12px */
        --lr-mx-14: ${unsafeCSS(theme.spacing(1.75))}; /* 0.875rem 14px */
        --lr-mx-16: ${unsafeCSS(theme.spacing(2))}; /* 1rem 16px */
        --lr-mx-18: ${unsafeCSS(theme.spacing(2.25))}; /* 1.125rem 18px */
        --lr-mx-20: ${unsafeCSS(theme.spacing(2.5))}; /* 1.25rem 20px */
        --lr-mx-26: ${unsafeCSS(theme.spacing(3.25))}; /* 1.625rem 16px */
        --lr-mx-32: ${unsafeCSS(theme.spacing(4))}; /* 2rem 16px */
        /* MARGINS SIZES HORIZONTAL */
        --lr-my-4: ${unsafeCSS(theme.spacing(1))}; /* 0.25rem 4px */
        --lr-my-8: ${unsafeCSS(theme.spacing(1))}; /* 0.5rem 8px */
        --lr-my-10: ${unsafeCSS(theme.spacing(1.25))}; /* 0.625rem 10px */
        --lr-my-12: ${unsafeCSS(theme.spacing(1.5))}; /* 0.75rem 12px */
        --lr-my-14: ${unsafeCSS(theme.spacing(1.75))}; /* 0.875rem 14px */
        --lr-my-16: ${unsafeCSS(theme.spacing(2))}; /* 1rem 16px */
        --lr-my-18: ${unsafeCSS(theme.spacing(2.25))}; /* 1.125rem 18px */
        --lr-my-20: ${unsafeCSS(theme.spacing(2.5))}; /* 1.25rem 20px */
        --lr-margin-small: var(--lr-py-12) var(--lr-px-20);
        --lr-margin-medium: var(--lr-py-14) var(--lr-px-26);
        --lr-margin-big: var(--lr-py-14) var(--lr-px-32);
        /* FONTS SIZES */
        --lr-text-12: ${unsafeCSS(theme.spacing(1.5))}; /* 0.75rem 12px */
        --lr-text-14: ${unsafeCSS(theme.spacing(1.75))}; /* 0.875rem 14px */
        --lr-text-15: ${unsafeCSS(theme.spacing(1.876))}; /* 0.875rem 14px */
        --lr-text-16: ${unsafeCSS(theme.spacing(2))}; /* 1rem 16px */
        --lr-text-18: ${unsafeCSS(theme.spacing(2.25))}; /* 1.125rem 18px */
        /* FONTS WEIGHT */
        --lr-font-100: 100;
        --lr-font-200: 200;
        --lr-font-300: 300;
        --lr-font-400: 400;
        --lr-font-500: 500;
        --lr-font-600: 600;
        --lr-font-700: 700;
        --lr-font-800: 800;
        --lr-font-900: 900;
        /* BORDERS RADIUS */
        --lr-border-radius: ${unsafeCSS(theme.defaults.radius)};
        /* BORDERS COLORS */
        --lr-border-color: ${unsafeCSS(theme.colors.semantic.fields.border.default)};
        --lr-border-color-hover: ${unsafeCSS(theme.colors.semantic.fields.border.hover)};
        --lr-border-color-active: ${unsafeCSS(theme.colors.semantic.fields.border.active)};
        --lr-border-color-disabled: ${unsafeCSS(theme.colors.semantic.fields.border.disabled)};
        --lr-border-color-error: ${unsafeCSS(theme.colors.semantic.fields.border.error)};
        --lr-border-color-success: ${unsafeCSS(theme.colors.semantic.fields.border.success)};
        /* FIELDS COLORS/BACKGROUND */
        --lr-field-bg-disabled: ${unsafeCSS(theme.colors.semantic.fields.background.disabled)};
        --lr-field-color: ${unsafeCSS(theme.colors.semantic.fields.content.default)};
        --lr-field-color-hover: ${unsafeCSS(theme.colors.semantic.fields.content.hover)};
        --lr-field-color-error: ${unsafeCSS(theme.colors.semantic.fields.content.error)};
        --lr-field-color-active: ${unsafeCSS(theme.colors.semantic.fields.content.active)};
        --lr-field-color-success: ${unsafeCSS(theme.colors.semantic.fields.content.success)};
        --lr-field-color-disabled: ${unsafeCSS(theme.colors.semantic.fields.content.disabled)};
        *,
        :after,
        :before {
            box-sizing: border-box;
        }

        b,
        strong {
            font-weight: 600 !important;
        }
        i {
            font-style: italic;
        }
        .no-scroll {
            overflow: hidden;
            overscroll-behavior: none;
            height: 100vh;
        }

        a[href],
        area[href],
        input:not([disabled]),
        select:not([disabled]),
        textarea:not([disabled]),
        button:not([disabled]),
        iframe,
        [tabindex],
        [contentEditable='true'] {
            ${focusBorderMixin()};
        }

        // IOS 15 Fix new default style
        button,
        select,
        input[type='button'],
        input[type='submit'],
        input[type='reset'],
        input[type='file'] {
            color: inherit;
        }
    }
`;
